import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { EMPTY, tap } from 'rxjs';
import { PagesTitle } from 'src/app/app-pages-title/app-pages-title';
import { SocialInitiative } from 'src/app/components/shared/social-initiative/social-initiative.abstract';
import { RouteService } from 'src/app/services/route-service.abstract';
import { MaybeUndefined } from 'src/app/utils';
import { SocialGroupEntity } from './social-group.interface';

@Injectable({ providedIn: 'root' })
export class InviteToSocialGroupRouteService<T extends SocialGroupEntity> extends RouteService<T, string> {
  public constructor(private socialInitiative: SocialInitiative<T>) {
    super();

    this.subscribeToData(socialInitiative.entityChanged$);
  }

  public loadData(id: string): void {
    this.socialInitiative.fetchEntityData(id);
  }

  public buildTitle({ title }: T): string {
    return this.translate(PagesTitle.SOCIAL_GROUP_INVITE_PAGE, { groupName: title });
  }

  public verifyAccess(_socialGroup: T): void {
    //
  }
}

export const socialGroupEntityResolver: <TEntity extends SocialGroupEntity>() => ResolveFn<TEntity> = <
  TEntity extends SocialGroupEntity,
>() => {
  return (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
    const entityId: MaybeUndefined<string> = route.paramMap.get('id');

    if (!entityId) {
      console.error('entity id should be provided');
      return EMPTY; // resolver will not emit any value and navigation will be canceled
    }

    const socialGroupRouteService = inject(InviteToSocialGroupRouteService<TEntity>);

    socialGroupRouteService.loadData(entityId);

    return socialGroupRouteService.data$.pipe(
      tap((data: TEntity) => {
        route.routeConfig.title = socialGroupRouteService.buildTitle(data);
      }),
    );
  };
};
